package org.example.project.engineservice.cr

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Text

@Composable
internal fun SysCRLayout(
    internalTitleVisible: Boolean,
    hasSelection: Boolean,
    onBack: () -> Unit,
    headerContent: @Composable () -> Unit,
    content: @Composable () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            width(100.percent)
            height(100.percent)
            backgroundColor(Color.transparent)
            color(Color.white)
            property("font-family", "Inter, system-ui, sans-serif")
            property("box-sizing", "border-box")
        }
    }) {
        Div({
            style {
                width(100.percent)
                height(100.percent)
                backgroundColor(Color.transparent)
                property("border", "none")
                borderRadius(0.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Row)
                alignItems(AlignItems.Stretch)
                property("box-sizing", "border-box")
                property("overflow", "visible")
                padding(18.px)
            }
        }) {
            Div({
                style {
                    width(72.px)
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.Center)
                    alignItems(AlignItems.Center)
                    opacity(if (hasSelection) 0.6 else 0.0)
                    property("pointer-events", if (hasSelection) "auto" else "none")
                    cursor("pointer")
                }
                onClick { onBack() }
            }) {
                Img(src = "images/back.svg") {
                    style {
                        width(28.px)
                        height(28.px)
                        property("filter", "brightness(0) invert(1)")
                    }
                }
            }

            Div({
                style {
                    flexGrow(1)
                    padding(40.px)
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    alignItems(AlignItems.Center)
                    property("box-sizing", "border-box")
                }
            }) {
                Div({
                    style {
                        width(100.percent)
                        maxWidth(600.px)
                        textAlign("center")
                    }
                }) {
                    if (internalTitleVisible) {
                        H2({ style { margin(0.px) } }) { Text("CR Aufträge") }
                    }
                    headerContent()
                }
                content()
            }

            Div({ style { width(72.px); opacity(0.0); property("pointer-events", "none") } }) {}
        }
    }
}
